/** Builds `?a=1&b=x` from a params object, skipping undefined and empty values. */
export function queryString(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') search.set(key, String(value));
  }
  const text = search.toString();
  return text === '' ? '' : `?${text}`;
}

export type Paginated<T> = { items: T[]; meta: { page: number; pageSize: number; total: number } };
export type Items<T> = { items: T[] };
